import { useTranslate } from 'core/hooks/useTranslate';
import PdfViewerFullScreen from 'core/modules/components/pdfViewers/PdfViewerFullScreen/PdfViewerFullScreen';
import * as coreEntities from 'core/store/index';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { TextHtml } from 'ui';

const TermsOfUse = () => {
  const { t } = useTranslate();
  const scopes = useSelector((state) => coreEntities.langs.selectors.getLangScopes(state));
  const [legal, setLegal] = useState('');
  const [showPdfViewer, setShowPdfViewer] = useState(false);

  useEffect(() => {
    if (scopes && scopes.length > 0) {
      let legalScope = scopes.filter((scope) => scope.scope === 'legal');
      if (legalScope && legalScope.length > 0) {
        setLegal(legalScope[0].json);
      }
    }
  }, [scopes]);

  useEffect(() => {
    if (legal?.endsWith('pdf')) {
      setShowPdfViewer(true);
    } else {
      setShowPdfViewer(false);
    }
  }, [legal]);

  return showPdfViewer ? (
    <div>
      <PdfViewerFullScreen url={legal} />
    </div>
  ) : (
    <div style={{ padding: '40px' }}>
      <TextHtml text={legal} />
    </div>
  );
};

export default TermsOfUse;
